/** 入学测试专属专项训练：在线刷题隐藏，入学测试列表展示且不计入分页 */
/** 临时关闭：设为 false 可对比隐藏前的专项训练数量，确认后再改回 true */
export const ENABLE_ENTRANCE_ONLY_PRACTICE_FILTER = true;

export const ENTRANCE_ONLY_PRACTICE_IDS = [
  "2063456951289819137",
  "2063456871136669697",
  "2063456815121739777",
  "2063456739464884226",
  "2063456679696052226",
  "2063456565854253058",
  "2063456509893849090",
  "2063456421477920770",
  "2063456346102083586",
  "2063456275486781442",
  "2063456125100011522",
  "2063456066019045378",
  "2063455754923323394",
];

export const ENTRANCE_ONLY_PRACTICE_ID_SET = new Set(ENTRANCE_ONLY_PRACTICE_IDS);

export const ENTRANCE_ONLY_PRACTICE_COUNT = ENTRANCE_ONLY_PRACTICE_IDS.length;

export function getPracticeItemId(item) {
  return String(item?.id ?? item?.goodsId ?? "");
}

export function isEntranceOnlyPractice(item) {
  if (!ENABLE_ENTRANCE_ONLY_PRACTICE_FILTER) {
    return false;
  }
  return ENTRANCE_ONLY_PRACTICE_ID_SET.has(getPracticeItemId(item));
}

export function filterOutEntranceOnlyPractice(list = []) {
  if (!ENABLE_ENTRANCE_ONLY_PRACTICE_FILTER) {
    return list;
  }
  return list.filter((item) => !isEntranceOnlyPractice(item));
}

export function countEntranceOnlyInList(list = []) {
  if (!ENABLE_ENTRANCE_ONLY_PRACTICE_FILTER) {
    return 0;
  }
  return list.filter(isEntranceOnlyPractice).length;
}

/** 统计当前筛选条件下，13 个专项里实际会出现在列表中的数量（用于修正分页总数） */
export async function resolveEntranceOnlyHiddenTotal(params, requestFn, totalCount) {
  if (!ENABLE_ENTRANCE_ONLY_PRACTICE_FILTER || !totalCount) {
    return 0;
  }
  const pageSize = Math.min(totalCount, 500);
  const res = await requestFn({
    ...params,
    pageCurrent: 1,
    pageSize,
  });
  return countEntranceOnlyInList(res?.list || []);
}

export function applyEntranceOnlyPracticeFilter(res, pageSize = 20, options = {}) {
  if (!ENABLE_ENTRANCE_ONLY_PRACTICE_FILTER) {
    return {
      list: res?.list || [],
      pageCurrent: res?.pageCurrent ?? 1,
      totalCount: res?.totalCount || 0,
      totalPage: res?.totalPage || 1,
    };
  }
  const list = filterOutEntranceOnlyPractice(res?.list || []);
  const hiddenTotalCount =
    options.hiddenTotalCount !== undefined
      ? options.hiddenTotalCount
      : ENTRANCE_ONLY_PRACTICE_COUNT;
  const totalCount = Math.max(0, (res?.totalCount || 0) - hiddenTotalCount);
  const totalPage = totalCount > 0 ? Math.ceil(totalCount / pageSize) : 1;
  return {
    list,
    pageCurrent: res?.pageCurrent ?? 1,
    totalCount,
    totalPage,
  };
}

/**
 * 过滤隐藏项后仍按 pageSize 凑满每一页（避免第 1 页只显示 7 条）
 */
export async function fetchFilteredPracticePage(
  baseParams,
  requestFn,
  displayPageCurrent,
  pageSize = 20,
  options = {}
) {
  if (!ENABLE_ENTRANCE_ONLY_PRACTICE_FILTER) {
    const res = await requestFn({
      ...baseParams,
      pageCurrent: displayPageCurrent,
      pageSize,
    });
    return {
      list: res?.list || [],
      pageCurrent: displayPageCurrent,
      totalCount: res?.totalCount || 0,
      totalPage: res?.totalPage || 1,
    };
  }

  const targetStart = (displayPageCurrent - 1) * pageSize;
  const targetEnd = displayPageCurrent * pageSize;
  let accumulated = [];
  let serverPage = 1;
  let serverTotalCount = 0;
  const serverPageSize = pageSize;

  while (accumulated.length < targetEnd) {
    const res = await requestFn({
      ...baseParams,
      pageCurrent: serverPage,
      pageSize: serverPageSize,
    });
    serverTotalCount = res?.totalCount || 0;
    const batch = filterOutEntranceOnlyPractice(res?.list || []);
    accumulated = accumulated.concat(batch);
    const rawList = res?.list || [];
    if (!rawList.length || rawList.length < serverPageSize) {
      break;
    }
    if (serverPage * serverPageSize >= serverTotalCount) {
      break;
    }
    serverPage += 1;
    if (serverPage > 100) {
      break;
    }
  }

  let hiddenTotalCount = options.hiddenTotalCount;
  if (hiddenTotalCount === undefined) {
    hiddenTotalCount = await resolveEntranceOnlyHiddenTotal(
      { ...baseParams, pageCurrent: 1, pageSize: serverPageSize },
      requestFn,
      serverTotalCount
    );
  }

  const totalCount = Math.max(0, serverTotalCount - hiddenTotalCount);
  const totalPage = totalCount > 0 ? Math.ceil(totalCount / pageSize) : 1;

  return {
    list: accumulated.slice(targetStart, targetEnd),
    pageCurrent: displayPageCurrent,
    totalCount,
    totalPage,
  };
}

export function sortByEntranceOnlyPracticeOrder(list = []) {
  return [...list].sort((a, b) => {
    const indexA = ENTRANCE_ONLY_PRACTICE_IDS.indexOf(getPracticeItemId(a));
    const indexB = ENTRANCE_ONLY_PRACTICE_IDS.indexOf(getPracticeItemId(b));
    return indexA - indexB;
  });
}
